import {
  getFristForhaandsvisning,
  type FristForhaandsvisningDTO,
  type InjunctionType,
} from "@/api/person/fristForhaandsvisning";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

export interface UseFristForhaandsvisningParams {
  type: InjunctionType;
  personId?: string;
  /** Kendelses- eller afgørelsesdatoen som yyyy-MM-dd. */
  kendelseDato?: string;
  periodeLaengdeMaaneder?: number;
}

export const fristForhaandsvisningQueryKey = (
  type: InjunctionType,
  personId: string,
  kendelseDato: string,
  periodeLaengdeMaaneder: number,
) =>
  [
    "fristForhaandsvisning",
    type,
    personId,
    kendelseDato,
    periodeLaengdeMaaneder,
  ] as const;

/**
 * Slår op, hvilke datoer en sag vil få. Kalder først, når både dato og længde er valgt —
 * uden dem har spørgsmålet ingen mening.
 *
 * Ingen debounce: begge felter er diskrete vælgere, så der kommer få ændringer.
 */
export const useFristForhaandsvisning = ({
  type,
  personId,
  kendelseDato,
  periodeLaengdeMaaneder,
}: UseFristForhaandsvisningParams): UseQueryResult<
  FristForhaandsvisningDTO,
  Error
> =>
  useQuery({
    queryKey: fristForhaandsvisningQueryKey(
      type,
      personId ?? "",
      kendelseDato ?? "",
      periodeLaengdeMaaneder ?? 0,
    ),
    queryFn: () =>
      getFristForhaandsvisning(
        type,
        personId!,
        kendelseDato!,
        periodeLaengdeMaaneder!,
      ),
    enabled: Boolean(personId && kendelseDato && periodeLaengdeMaaneder),
  });
